const SET_BOOKS = 'SET_BOOKS'
const SET_BOOK = 'SET_BOOK'
const SET_IS_BOOKS_LOADING = 'SET_IS_BOOKS_LOADING'
const SET_START_INDEX = 'SET_START_INDEX'
const REMOVE_BOOKS = 'REMOVE_BOOKS'
const SET_TOTAL_ITEMS = 'SET_TOTAL_ITEMS'

export  {
    SET_BOOKS,
    SET_BOOK,
    SET_IS_BOOKS_LOADING,
    REMOVE_BOOKS,
    SET_TOTAL_ITEMS,
    SET_START_INDEX
}